// ============================================================================
// Pré-validation d'une entrée vendeur Vestiaire (id, URL de profil ou pseudo) — la
// résolution FAIT FOI côté serveur (parseVestiaireSellerRef) ; ceci n'évite que les
// allers-retours sur une saisie manifestement fausse (URL Vinted collée sur l'onglet VC).
// ============================================================================

const MAX_INPUT_LENGTH = 256;

// Liste blanche EXPLICITE des domaines Vestiaire Collective. Un motif générique de TLD, même
// borné à 2-3 lettres, laissait passer des domaines que VC ne possède pas
// (vestiairecollective.co.io, vestiairecollective.com.ev) en plus des hôtes usurpateurs
// (vestiairecollective.com.evil.io). Tout sous-domaine d'un domaine listé est accepté (fr., www., us.).
const VESTIAIRE_DOMAINS = [
  'vestiairecollective.com',
  'vestiairecollective.fr',
  'vestiairecollective.co.uk',
  'vestiairecollective.de',
  'vestiairecollective.it',
  'vestiairecollective.es',
  'vestiairecollective.nl',
  'vestiairecollective.be',
  'vestiairecollective.ch',
  'vestiairecollective.at',
  'vestiairecollective.dk',
  'vestiairecollective.se',
  'vestiairecollective.com.au',
  'vestiairecollective.hk',
  'vestiairecollective.sg',
  'vestiairecollective.jp',
  'vestiairecollective.us',
] as const;

const isVestiaireHost = (hostname: string): boolean => {
  const host = hostname.toLowerCase();
  return VESTIAIRE_DOMAINS.some((domain) => host === domain || host.endsWith(`.${domain}`));
};

export const isPlausibleVestiaireSellerInput = (value: string): boolean => {
  const raw = value.trim();
  if (raw === '' || raw.length > MAX_INPUT_LENGTH) return false;
  if (/^\d+$/.test(raw)) return true;
  if (raw.includes('/')) {
    try {
      return isVestiaireHost(new URL(raw).hostname);
    } catch {
      return false;
    }
  }
  return raw.replace(/^@/, '').length > 0;
};

export const vestiaireNameFromInput = (value: string): string => {
  const raw = value.trim();
  if (raw === '' || raw.includes('/') || /^\d+$/.test(raw)) return '';
  return raw.replace(/^@/, '');
};
